import Columns from './Columns'

let KendoGridColumn = {
    name: 'kendo-multicolumncombobox-column',
    render () {
        return null
    },
    mixins: [Columns]
}

export default KendoGridColumn


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoMultiColumnComboBox/KendoMultiColumnComboBoxColumn.js